import gsap from 'gsap';

import { Basics, isMobile, isTouch } from '../_app/cuchillo/core/Basics';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import { GetBy } from '../_app/cuchillo/core/Element';
import Default from './Default';
import Main from '../main';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { OLMaps } from '../components/OLMaps';
import VScroll from '../_app/cuchillo/scroll/VScroll';
import FiltersWindow from '../windows/FiltersWindow';

export default class Activities extends Default {
  filterButton;
  filters = [];
  toggles = [];
  cards;
  footer;
  filterBanner;
  filtersShown = true;

  filtersDrawerEl;
  filtersDrawerContent;
  filtersWindow;
  filtersReset;
  engine;

  listContainer;
  links;

  _calls = {
    click: e => {
      const btn = e.target;
      const siblings = GetBy.class('__filter', btn.parentNode);

      for (let i = 0; i < siblings.length; i++) {
        siblings[i].classList.remove('--active');
      }

      btn.classList.add('--active');
      this._calls.filter();
    },

    toggle: e => {
      const btn = e.target;
      btn.classList.toggle('--selected');
      this._calls.filter();
    },

    filter: () => {
      const params = this._calls.setURL();
      this._calls.readURL(params);

      OLMaps.dispose();
      OLMaps.init();

      Scroll.goto(0);
      Scroll.resize();
    },

    setURL: () => {
      const categs1 = this.toggles
        .filter(toggle => toggle.classList.contains('--selected') && !toggle.dataset.categ.includes('all'))
        .map(toggle => toggle.dataset.categ);

      const categs2 = this.filters
        .filter(filter => filter.classList.contains('--active') && !filter.dataset.categ.includes('all'))
        .map(filter => filter.dataset.categ);

      const categs = [...categs1, ...categs2];

      // const params = new URLSearchParams();

      // Start with current params (preserve utm, fbclid, etc.)
      const params = new URLSearchParams(window.location.search);

      // Remove old filters
      [...params.keys()].forEach(key => {
        if (this._isFilterKey(key)) params.delete(key);
        else {
          console.log('NOT FILTERED', key);
        }
      });

      categs.forEach(categ => {
        const [key, value] = categ.split('-');
        if (!value) params.append(key, '');
        else params.set(key, categ);
      });

      this._calls.updateUrl(params);

      return params; // OPT: retorna params per reutilitzar
    },

    readURL: (params = null) => {
      if (!params) params = new URLSearchParams(window.location.search);
      const categs = this._getCategsFromParams(params).filter(c => c !== 'active_now').map(c => `__categ-${c}`);
      const activeNow = this._getCategsFromParams(params).filter(c => c === 'active_now').length > 0;

      for (let i = 0; i < this.cards.length; i++) {
        const card = this.cards[i];
        let active = categs.every(categ => card.classList.contains(categ));

        if (activeNow && card.dataset.horario) {
          if (card.dataset.horario) {
            const horarios = JSON.parse(card.dataset.horario);
            active = active && this._isActiveNow(horarios);
          } else {
            active = false;
          }
        }

        card.classList.toggle('--hidden', !active);
      }
    },

    selectFiltersFromUrl: () => {
      if (!this.filterButton) return;

      const categs = this._getCategsFromUrl();

      // Radio groups (days/times/signup): default to "-all" when the URL has
      // no selection for that group, so something is always shown as active.
      const groups = [...new Set(this.filters.map(f => f.dataset.categ.split('-')[0]))];
      groups.forEach(key => {
        if (!categs.some(c => c.startsWith(key + '-'))) categs.push(`${key}-all`);
      });

      for (let i = 0; i < this.toggles.length; i++) {
        this._setActiveFilter(this.toggles[i], '--selected', categs);
      }

      for (let i = 0; i < this.filters.length; i++) {
        this._setActiveFilter(this.filters[i], '--active', categs);
      }
    },

    updateUrl: (params) => {
      const queryString = this._getQueryStringFromParams(params);
      const newURL = `${window.location.pathname}${queryString}`;
      window.history.replaceState({}, '', newURL);
      sessionStorage.setItem('lastListingUrl', newURL);

      this._updateLinksHref(params);
    },

    reset: () => {
      for (let i = 0; i < this.filters.length; i++) {
        const filter = this.filters[i];
        filter.classList.toggle('--active', filter.dataset.categ.includes('-all'));
      }

      for (let i = 0; i < this.toggles.length; i++) {
        this.toggles[i].classList.remove('--selected');
      }

      this._calls.filter();
    }
  }

  constructor() {
    super();

    this.footer = GetBy.id('Footer');
    this.filterBanner = GetBy.id('FilterBanner');

    document.documentElement.classList.add('--project');

    this.links = GetBy.class('__link');

    this.filterButton = GetBy.id('filters-toggle');
    if (this.filterButton) {
      this.filters = [...GetBy.class('__filter', this.container)];
      for (let i = 0; i < this.filters.length; i++) {
        this.filters[i].addEventListener(Basics.clickEvent, this._calls.click);
      }

      this.toggles = [...GetBy.class('__toggle', this.container)];
      for (let i = 0; i < this.toggles.length; i++) {
        this.toggles[i].addEventListener(Basics.clickEvent, this._calls.toggle);
      }

      this.filtersReset = GetBy.id('filters-reset');
      if (this.filtersReset) this.filtersReset.addEventListener(Basics.clickEvent, this._calls.reset);

      this.filtersDrawerEl = GetBy.id('FiltersDrawer');
      if (this.filtersDrawerEl) {
        this.filtersWindow = new FiltersWindow(this.filtersDrawerEl, 'filters');

        this.filtersDrawerContent = GetBy.selector('.content', this.filtersDrawerEl)[0];
        if (this.filtersDrawerContent) {
          // Desktop: default easing gives the smooth wheel-driven catch-up.
          // Touch: easing 1 makes position snap straight to target each frame,
          // so the content tracks the finger 1:1 instead of trailing behind it.
          this.engine = new VScroll({
            container: this.filtersDrawerContent,
            isMain: false,
            easing: isTouch ? 1 : undefined
          });
          this.engine.addAll('[scroll-filters-item]');
          this.engine.resize();
          this.filtersWindow.engine = this.engine;
        }
      }
    }

    this.cards = [...GetBy.class('__card', this.container)];
    this.listContainer = GetBy.id('ProjectList');
  }

  _isFilterKey(key) {
    // valid keys are derived from your filters/toggles

    const validKeys = [
      ...this.filters.map(f => (f.dataset.categ.includes('-') ? f.dataset.categ.split('-')[0] : f.dataset.categ)),
      ...this.toggles.map(t => (t.dataset.categ.includes('-') ? t.dataset.categ.split('-')[0] : t.dataset.categ))
    ];
    return validKeys.includes(key);
  }

  _getCategsFromUrl() {
    const params = new URLSearchParams(window.location.search);
    return this._getCategsFromParams(params);
  }

  _getCategsFromParams(params) {
    const valid = [
      ...this.filters.map(f => f.dataset.categ),
      ...this.toggles.map(t => t.dataset.categ)
    ];

    const categs = [];
    for (const [key, value] of params.entries()) {
      const val = value === '' ? key : value;
      if (valid.includes(val)) {
        categs.push(val);
      }
    }
    return categs;
  }

  _getQueryStringFromParams(params) { // OPT: helper consolidat
    let queryString = Array.from(params.entries())
      .map(([key, value]) => value === '' ? key : `${key}=${value}`)
      .join('&');
    return queryString.length > 0 ? '?' + queryString : '';
  }

  _updateLinksHref(params) {
    const queryString = this._getQueryStringFromParams(params);
    for (let i = 0; i < this.links.length; i++) {
      const link = this.links[i];
      const baseHref = link.href.split('?')[0];
      link.href = baseHref + queryString;
    }
  }

  _setActiveFilter(element, className, activeList) { // OPT: helper unificat
    element.classList.remove(className);
    if (activeList.includes(element.dataset.categ)) {
      element.classList.add(className);
    }
  }

  _isActiveNow(horarios = []) {
    const now = new Date();
    const dia = new Intl.DateTimeFormat('es-ES', { weekday: 'long' }).format(now).toLowerCase();
    const hora = now.getHours().toString().padStart(2, '0') + ':' + now.getMinutes().toString().padStart(2, '0');

    return horarios.some(h => {
      const diaH = h.dia.toLowerCase();
      const horaInicio = this._to24h(h.hora_inicio);
      const horaFin = this._to24h(h.hora_fin);

      // console.log('Dia', h.dia, dia);
      // console.log('Inicio', hora, horaInicio);
      // console.log('Fin', hora, horaFin);
      // console.log('Active now', diaH === dia && hora >= horaInicio && hora <= horaFin);

      // Evita comparació si alguna conversió ha fallat
      if (!horaInicio || !horaFin) return false;

      return diaH === dia && hora >= horaInicio && hora <= horaFin;
    });
  }

  _to24h(horaStr) {
    if (!horaStr || typeof horaStr !== 'string') return null;

    // Netejar: treure espais extres i posar en minúscules
    const clean = horaStr.trim().toLowerCase();

    // Si ja està en format 24h (ex: "17:00")
    if (/^\d{1,2}:\d{2}$/.test(clean) && !clean.includes('am') && !clean.includes('pm')) {
      return clean.padStart(5, '0');
    }

    // Si està en format amb am/pm (ex: "3:00 pm")
    const match = clean.match(/^(\d{1,2}):(\d{2})\s?(am|pm)$/);
    if (!match) return null;

    let [_, hh, mm, period] = match;
    hh = parseInt(hh);
    mm = parseInt(mm);

    if (period === 'pm' && hh < 12) hh += 12;
    if (period === 'am' && hh === 12) hh = 0;

    return hh.toString().padStart(2, '0') + ':' + mm.toString().padStart(2, '0');
  }

  beforeShow() {
    super.beforeShow();

    const params = new URLSearchParams(window.location.search);
    this._calls.readURL(params);
    this._calls.selectFiltersFromUrl();
    this._calls.updateUrl(params);

    OLMaps.dispose();
    OLMaps.init();
  }

  beforeHide() {
    super.beforeHide();

    if (this.filterButton) {
      for (let i = 0; i < this.filters.length; i++) {
        this.filters[i].removeEventListener(Basics.clickEvent, this._calls.click);
      }

      for (let i = 0; i < this.toggles.length; i++) {
        this.toggles[i].removeEventListener(Basics.clickEvent, this._calls.toggle);
      }

      if (this.filtersReset) this.filtersReset.removeEventListener(Basics.clickEvent, this._calls.reset);

      if (this.filtersWindow) this.filtersWindow.hide();
      if (this.engine) this.engine.dispose();
    }
  }

  afterHide() {
    super.afterHide();
    document.documentElement.classList.remove('--project');
  }

  resize() {
    super.resize();
    if (this.engine) this.engine.resize();
  }

  loop() {
    super.loop();

    if (this.engine) this.engine.loop();

    if (isMobile || !this.filterBanner) return;

    const { top } = this.footer.getBoundingClientRect();
    const p = top - window.innerHeight;

    if (p < 0 && this.filtersShown) {
      gsap.to(this.filterBanner, { opacity: 0, duration: .2 });
      this.filterBanner.style.pointerEvents = 'none';
      this.filterBanner.style.visibility = 'hidden';
      this.filtersShown = false;
    } else if (p > 0 && !this.filtersShown) {
      this.filterBanner.style.pointerEvents = 'initial';
      this.filterBanner.style.visibility = 'visible';
      gsap.to(this.filterBanner, { opacity: 1, duration: .3 });
      this.filtersShown = true;
    }
  }
}

ControllerPage._addPage('activities', Activities);